module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', {
    attrs: {
      "id": "badge-zu-jian"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#badge-zu-jian",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" Badge 组件")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "ji-chu-yong-fa"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#ji-chu-yong-fa",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 基础用法")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "hljs language-html"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge-group")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("active-key")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"2\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mark")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"0\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"热销榜\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("info")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"8\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"http://baidu.com\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mark")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"1\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"花式寿司\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("info")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"99\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mark")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"2\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"火炽寿司\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mark")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"3\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"手握寿司\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("info")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"199\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("zan-badge-group")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "z-badge-group-api"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#z-badge-group-api",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" z-badge-group API")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("必须")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("active-key")]), _vm._v(" "), _c('td', [_vm._v("激活的badge的索引")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("'0'但必须子badge里的mark是有0位索引")]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "z-badge-api"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#z-badge-api",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" z-badge API")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("必须")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("mark")]), _vm._v(" "), _c('td', [_vm._v("badge的唯一key值")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("''")]), _vm._v(" "), _c('td', [_vm._v("required")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("badge的文案标题")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("''")]), _vm._v(" "), _c('td', [_vm._v("required")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("info")]), _vm._v(" "), _c('td', [_vm._v("当前badge的提示消息数量")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("''")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("url")]), _vm._v(" "), _c('td', [_vm._v("跳转链接")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("全连接直接跳转或者hash")]), _vm._v(" "), _c('td')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e71687a8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/badge-1.vue
// module id = 305
// module chunks = 0